import {
  buildCohortMatch,
  sortCohortsForReview,
} from '../../domain/services/cohortAssignmentReviewService';

/** @typedef {
 *   import('./createCareModelCohortSuggestion.types').GetSuggestedCohortForClientParams
 * } GetSuggestedCohortForClientParams */
/** @typedef {
 *   import('./createCareModelCohortSuggestion.types').CareModelCohortSuggestionUseCase
 * } CareModelCohortSuggestionUseCase */
/** @typedef {
 *   import('../../domain/entities/CareModelCohortAssignment.types').CareModelCohortMatch
 * } CareModelCohortMatch */

/**
 * @param {Function} hydrateFilters
 * @param {Function} getFilteredElements
 * @returns {CareModelCohortSuggestionUseCase}
 */
// eslint-disable-next-line import/prefer-default-export
export function createCareModelCohortSuggestion(
  hydrateFilters,
  getFilteredElements,
) {
  /**
   * @param {GetSuggestedCohortForClientParams} params
   * @returns {CareModelCohortMatch | null}
   */
  function getSuggestedCohortForClient({ client, cohorts = [], columns = [] }) {
    if (!client) {
      return null;
    }

    const sortedCohorts = sortCohortsForReview(cohorts);

    const matches = sortedCohorts.reduce((acc, cohort) => {
      const hydratedFilters = hydrateFilters(cohort.filters || {}, columns);
      const matchedClients = getFilteredElements([client], hydratedFilters);

      if (!matchedClients.length) {
        return acc;
      }

      acc.push(buildCohortMatch(cohort, hydratedFilters));
      return acc;
    }, []);

    if (matches.length !== 1) {
      return null;
    }

    return matches[0];
  }

  return {
    getSuggestedCohortForClient,
  };
}
